module.exports = "https://cdn-challenge.mathletics.com/app/275/assets/fonts/a9382e25bcf75d856718fcef54d7acdb.woff2";